export default "__VITE_ASSET__6IMH98OV__"